import { useTranslation } from '@kb/i18n';
import { useMutation } from '@ocp/graphql-client';
import { notifyDanger } from '@ocp/notifications';
import i18nKeys from '../i18n/index';
const CLEAR_COMPARISON_MUTATION = `
  mutation {
    deleteAllContentsFromComparison
  }
`;
export default function useClearComparisonMutation() {
    const { t } = useTranslation();
    return useMutation(CLEAR_COMPARISON_MUTATION, {
        onError: (e) => {
            console.error(e);
            notifyDanger(t(i18nKeys.ERROR_IS_OCCURED));
        },
    });
}
